import {COOKIE_DOMAIN, SPOTMENTOR_ENV} from "../config";

const SERVER_ENV = {
  DEV: 'dev',
  DABBA: 'dabba',
};

const redirectInstance = SPOTMENTOR_ENV === 'refresh_token_development' ? 'dabba' : 'test'
const redirectProtocol = redirectInstance === 'test' ? 'https' : 'http';
const PLATFORM_URL = {
  [SERVER_ENV.DEV]: `${redirectProtocol}://${COOKIE_DOMAIN}:3002`,
  [SERVER_ENV.DABBA]: `http://some-org.${redirectInstance}.spotmentor.com`,
};

const configuredPlatformUrl = process.env.PLATFORM_URL;
const isIntranet = host => host.includes('dabba');

const getEnvironment = host => {
  if (__DEV__) {
    return SERVER_ENV.DEV;
  }

  if (isIntranet(host)) {
    return SERVER_ENV.DABBA;
  }

  return undefined;
};

const getDefaultPlatformUrlForEnvironment = (
  organizationSubdomain,
  websiteHost,
) => {
  const serverEnv = getEnvironment(websiteHost);
  const defaultUrl = PLATFORM_URL[serverEnv];

  return defaultUrl || organizationSubdomain;
};

const getPlatformUrl = ({ organizationSubdomain, websiteHost }) => {
  /*
  get url for spotmentor's learning interface platform
  based on the current running environment and
  organization's registered subdomain on spomentor

  usually used for redirection after a user logs in
  */

  console.info('calculating platform url', {
    organizationSubdomain,
    websiteHost,
    configuredPlatformUrl,
  });

  if (configuredPlatformUrl) {
    return configuredPlatformUrl;
  }

  const platformUrl = getDefaultPlatformUrlForEnvironment(
    organizationSubdomain,
    websiteHost,
  );

  console.info(`platformUrl evaluated to ${platformUrl}`);

  return platformUrl;
};

export default getPlatformUrl;



// WEBPACK FOOTER //
// ./src/utils/login.js